import { wsConnect } from '../actions/websocket';
import envConfig from '../../envConfig';

const jwtMiddleware = () => (store) => (next) => async (action) => {
  switch (action.type) {
    case 'jwt/fetchToken/fulfilled':
      store.dispatch(wsConnect(envConfig.wsUrl, action.payload));
      break;
    default:
      break;
  }
  return next(action);
};

export default jwtMiddleware();
